import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { PainPoints } from './components/PainPoints';
import { Outcomes } from './components/Outcomes';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { ForYou } from './components/ForYou';
import { FeaturedStory } from './components/FeaturedStory';
import { Testimonials } from './components/Testimonials';
import { WhatYouGet } from './components/WhatYouGet';
import { PricingCta } from './components/PricingCta';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="w-full bg-cream" data-id="element-0" data-mp="2wi5m1f302hnq">
      <MetaPixel data-id="element-1" data-mp="28tmi1bqzgr1g" />
      <Hero data-id="element-2" data-mp="28t4j27cxrypu" />
      <Stats data-id="element-3" data-mp="28sl48zil1qg1" />
      <PainPoints data-id="element-4" data-mp="28sbe9bxjfjac" />
      <Outcomes data-id="element-5" data-mp="23vkwmk634fmt" />
      <Modules data-id="element-6" data-mp="23vulg4fe8gqx" />
      <Bonuses data-id="element-7" data-mp="23u9vyt7xrnzx" />
      <ForYou data-id="element-8" data-mp="23utb6267bya9" />
      <FeaturedStory data-id="element-9" data-mp="23t8i6gzjcnei" />
      <Testimonials data-id="element-10" data-mp="3ijxokogyjwiu" />
      <WhatYouGet data-id="element-11" data-mp="3ikh5q2ysagvt" />
      <PricingCta data-id="element-12" data-mp="3ij652c0mxp8x" />
      <Faq data-id="element-13" data-mp="3ijpbavgxap74" />
      <FinalCta data-id="element-14" data-mp="3ihv0i9zd8dgr" />
      <Footer data-id="element-15" data-mp="3mlj8gtrwtb2j" />
    </main>;
}